module.exports = __webpack_public_path__ + "img/role-video.11dec774.png";